import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import classes from "../../CompetitionInfo.module.css";
import { GlobalContext } from "../../../../common/Context";

const InfoModal = (props) => {
  const { open, onClose, title, options } = props;
  const { mobileView, tabletView, desktopView } = useContext(GlobalContext);

  const [selection, setSelection] = useState(null);

  useEffect(() => {
    if (open > -1) setSelection(options[open]);
  }, [open]);

  const containerStyle = {
    "& .MuiDialog-paper": {
      borderRadius: "1rem",
      height: !desktopView ? "90vh" : "50vh",
      maxWidth: !desktopView ? "95vw" : "60vw",
    },
  };
  const titleStyle = {
    fontWeight: 600,
    fontSize: "2rem",
    backgroundColor: "#F2F2F2",
    pb: 0,
    position: "relative",
  };
  const buttonBoxStyle = {
    display: "flex",
    justifyContent: !desktopView ? "space-around" : "flex-start",
  };
  const buttonStyle = (selected) => ({
    fontWeight: selected ? 800 : 600,
    fontSize: "1rem",
    p: "0.5rem 0",
    borderBottom: selected ? "8px solid #3C7BF6" : "none",
    mr: !desktopView ? 0 : 2,
    borderRadius: 0,
    pb: selected ? 0 : "8px",
    textTransform: "none",
  });
  const contentStyle = {
    p: "0 12px 0 24px",
    m: "20px 12px 20px 0",
    width: "auto",
  };
  const iconStyle = {
    position: "absolute",
    top: "0.75rem",
    right: "0.75rem",
    fontSize: "1rem",
  };
  const campaignTitleStyle = {
    mt: !mobileView && "0.5rem",
    mb: tabletView ? "0.75rem" : "1rem",
    fontSize: desktopView ? "1.25rem" : "1rem",
  };
  const textStyle = {
    lineHeight: 1.5,
    whiteSpace: "pre-line",
  };

  return (
    <Dialog open={open > -1} onClose={onClose} sx={containerStyle}>
      <DialogTitle sx={titleStyle}>
        {title}
        <Box sx={buttonBoxStyle}>
          {options.map((option) => (
            <Box key={option.button}>
              <Button
                sx={buttonStyle(option.button == selection?.button)}
                onClick={() => setSelection(option)}>
                {option.button}
              </Button>
            </Box>
          ))}
        </Box>
        <CloseIcon sx={iconStyle} onClick={onClose} />
      </DialogTitle>
      <DialogContent
        sx={contentStyle}
        className={[classes.scrollBoxStyle, classes.lightScrollBox].join(" ")}>
        <Typography variant="h2" sx={campaignTitleStyle}>
          {selection?.title}
        </Typography>
        <Typography sx={textStyle}>{selection?.description}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
